import request from '../../utils/request'
// 获取商品模版信息
const getChannelGoods = (template,modify_mark) => {
    return request({
        url: process.env.VUE_APP_API + `particulars/channel/goods?modify_mark=${modify_mark}&template=${template}`,
        method: 'GET',
    })
}
// 模版电子码购买
const electronicCode = (data) => {
    return request({
        url: process.env.VUE_APP_TRADER + `order/electronic-code`,
        method: 'POST',
        data,
    })
}
export {
    getChannelGoods,
    electronicCode
}